import React from 'react';
import { ChatAttachmentPreviewSC } from './chat-window.styled';

type TProps = {
  type: string;
  name: string;
  preview?: string;
  onRemove(): void;
};

const ChatAttachmentPreview: React.FC<TProps> = ({ name, type, preview, onRemove }) => {
  if (!preview) {
    return null;
  }

  return (
    <ChatAttachmentPreviewSC>
      {type.includes('image') ? (
        <img className="cap-preview" src={preview} alt="" />
      ) : (
        <div className="cap-name">{name}</div>
      )}
      <button className="cap-delete" type="button" onClick={onRemove}>
        <img src={require('../../assets/svg/icon-cross-black.svg').default} alt="Remove" />
      </button>
    </ChatAttachmentPreviewSC>
  );
};

export default ChatAttachmentPreview;
